
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0fb0e1","d":"M2.2 4.5l7.5 28.4h2.5l7-10.8 11-4.4v-2.5L4 3c-.5-.2-1-.1-1.4.2-.4.3-.6.8-.4 1.3zm2.5 1.1l23 10.8-9.9 4-6.5 10.1L4.7 5.6z"}})])
          )
        }
      }
    